import { selectEmvPaymentModuleState } from '@ticketmaster/tm1pos-web-shared/payment/emvPaymentModule-selectors';
import { selectLanguage } from '@ticketmaster/tm1pos-web-shared/translations';
import { createSelector } from 'reselect';

export const selectDeliveryFormState = createSelector(
  [selectLanguage, selectEmvPaymentModuleState],
  (language, emvPaymentModuleState) => ({
    locale: language,
    shouldRequireFullName: emvPaymentModuleState.rules.shouldRequireFullName,
    isEmvSupported: emvPaymentModuleState.isEmvSupported,
  }),
);
